var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mx-0 pa-0",attrs:{"id":"dashboard","fluid":"","grid-list-lg":""}})}
var staticRenderFns = []

export { render, staticRenderFns }